module.exports = __webpack_public_path__ + "static/cart-91072149860c8e5281cbf7a1d8d1df93.png";